import styled from "styled-components";

export const ContainerTitle = styled.div`
  margin-left: 16px;
  ${({ theme }) => theme.smartphone} {
    margin-top: 19px;
    margin-left: 0px;
  }
`;
